<template>
  <b-row
    class="grupo-atividade mt-1"
  >
    <b-col>
      <!-- Parte de visualização -->
      <b-row
        v-if="estado === 'visualizacao'"
        align-h="between"
        class="mb-50"
      >
        <b-col
          cols="6"
          @click.stop="edit()"
        >
          <span style="font-size: 1.35rem;font-weight: 500;">{{ checklistGrupo.tipoAtividade.nome }}</span>
        </b-col>
        <b-col cols="auto">
          <b-btn
            variant="outline-info"
            class="btn btn-sm mr-1"
            @click="edit()"
          >
            <feather-icon icon="Edit2Icon" />
          </b-btn>
          <b-btn
            variant="outline-danger"
            class="btn btn-sm"
            @click.stop="remove()"
          >
            <feather-icon icon="TrashIcon" />
          </b-btn>
        </b-col>
      </b-row>
      <!--Edição-->
      <b-row
        v-else
        align-h="between"
      >
        <b-col
          cols="6"
        >
          <atividade-select
            ref="atividadeSelect"
            v-model="checklistGrupo.tipoAtividade"
            :label="'Tipo de atividade para o grupo'"
            :filtro-adicional="removeAtividadesRepetidas"
            @input="atividadeSelecionada"
            @tecla-enter="addItemChecklist"
          />
        </b-col>
        <b-col
          cols="auto"
          align-self="center"
        >
          <b-btn
            variant="outline-danger"
            class="btn btn-sm"
            @click.stop="remove()"
          ><feather-icon icon="TrashIcon" /></b-btn>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <hr
            class="mx-0 mt-0 mb-50"
            style="border-top: 0.15px solid #00000057 !important;"
          >
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="d-block w-100">
            <draggable
              v-model="itensChecklistGrupo"
              v-bind="dragOptions"
              @start="drag=true"
              @end="drag=false"
              @change="onChange"
            >
              <item-checklist
                v-for="(itemChecklist, $index) in itensChecklistGrupo"
                :key="itemChecklist.id > 0 ? itemChecklist.id : itemChecklist.code"
                :ref="`itemCheck${itemChecklist.id > 0 ? itemChecklist.id : itemChecklist.code}`"
                v-model="itensChecklistGrupo[$index]"
                :state="itemChecklist.state"
                :tributacao-id="tributacaoSelecionadaId"
                :atividade-id="atividadeSelecionadaId"
                @edicao-atual="setEdicaoAtual($event)"
                @add-item="addItemChecklist"
                @remove="removeItem"
              />
            </draggable>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="ml-1 mt-1">
          <a
            class="text-primary hover-item"
            style="cursor:pointer;font-size:12.5px"
            @click.stop="addItemChecklist"
          ><span><i class="fas fa-plus-circle" />&nbsp;Adicionar nova pergunta ao checklist</span></a>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<style lang="scss">
.grupo-atividade {
  border-radius: 4px;
  padding: 0.2rem 0.6rem;
  &:hover {
    cursor: pointer;
    background-color: rgba(24, 28, 33, 0.06);
  }

  .btn-sm {
    padding: 0.45rem 0.9rem;
  }
}

.hover-item.text-primary:hover {
  color: #1b874a !important;
}

.template .card {
  min-width: 38rem;
  max-width: 50rem;
  width: 100%;
}

textarea{
  margin-bottom: 10px;
}

.activitytemplate {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;

  .addgroup {
    margin: 1.5rem 1.5rem 0 1.5rem;
  }
}

  .flip-list-move {
    transition: transform 0.5s;
  }
  .no-move {
    transition: transform 0s;
  }
.ghost {
  opacity: 0.5;
  background: #ffff !important;
}
</style>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'AtividadeChecklistGrupo',
  components: {
    draggable,
    AtividadeSelect: () => import('@/shared/components/tipo-atividade-select/TipoAtividadeSelect.vue'),
    ItemChecklist: () => import('@/app-modulo/comercial/parametrizacao-checklist-honorarios/shared/components/item-checklist/ItemChecklist.vue'),
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    state: {
      type: String,
      required: true,
      default: 'visualizacao',
    },
    parametrizacao: {
      type: Array,
      default: () => [],
    },
    tributacaoId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      checklistGrupo: this.value,
      estado: '',
      itensChecklistGrupo: [],
      objetoExistente: null,
      tributacaoSelecionadaId: 0,
      atividadeSelecionadaId: 0,
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      }
    },
  },
  watch: {
    state(value, oldValue) {
      if (value !== oldValue) {
        this.estado = value
      }
    },
    tributacaoId(value, oldValue) {
      if (value !== oldValue) {
        this.tributacaoSelecionadaId = value
      }
    },
  },
  created() {
    this.checklistGrupo = this.value
    this.estado = this.checklistGrupo.id === 0 ? 'criacao' : this.state
    this.$set(this.checklistGrupo, 'state', this.estado)
    if (this.checklistGrupo.itensChecklist) {
      this.itensChecklistGrupo = this.checklistGrupo.itensChecklist
    }

    this.tributacaoSelecionadaId = this.tributacaoId

    if (this.checklistGrupo.tipoAtividade) {
      this.atividadeSelecionadaId = this.checklistGrupo.tipoAtividade.id
    }
  },
  methods: {
    remove() {
      this.$emit('remove', this.checklistGrupo)
    },
    addItemChecklist() {
      if (!this.hasErrors()) {
        const item = {
          code: Date.now().toString(36) + Math.random().toString(36).substring(2),
          id: 0,
          state: 'criacao',
        }

        if (!this.checklistGrupo.itensChecklist) {
          this.checklistGrupo.itensChecklist = []
        }

        if (this.checklistGrupo.id === 0) {
          this.checklistGrupo.itensChecklist.push(item)
          this.itensChecklistGrupo.push(item)
        } else {
          this.itensChecklistGrupo.push(item)
        }
        this.$emit('edicao-atual', item)
      }
    },
    hasErrors() {
      if (!this.checklistGrupo.tipoAtividade) {
        this.$refs.atividadeSelect.$refs.tipoAtividadeSelect.$refs.selectBaseSelect.$refs.search.focus()
        return true
      }
      const itemSemDescricao = this.itensChecklistGrupo.find(fin => !fin.descricao || fin.descricao === '')
      if (itemSemDescricao) {
        this.$refs[`itemCheck${itemSemDescricao.id > 0 ? itemSemDescricao.id : itemSemDescricao.code}`][0].hasErrors()
        return true
      }
      return false
    },
    removeItem(value) {
      this.itensChecklistGrupo = this.itensChecklistGrupo.filter(fil => (fil.id > 0 && fil.id !== value.id) || (fil.code && fil.code !== value.code))
      if (!this.checklistGrupo.itensChecklist) {
        this.checklistGrupo.itensChecklist = []
      }
      this.checklistGrupo.itensChecklist = this.checklistGrupo.itensChecklist.filter(fil => (fil.id > 0 && fil.id !== value.id) || (fil.code && fil.code !== value.code))
    },
    edit() {
      this.estado = 'edicao'
      this.checklistGrupo.state = this.estado

      this.$emit('edicao-atual', this.checklistGrupo)
    },
    setEdicaoAtual(event) {
      const itemCheck = this.itensChecklistGrupo.find(find => (!find.descricao || find.descricao === '') && !find.tipoRegra)
      if (itemCheck) {
        this.removeItem(itemCheck)
      }
      this.$emit('edicao-atual', event)
    },
    removeAtividadesRepetidas(atividades) {
      if (this.parametrizacao) {
        const atividadesExistentes = this.parametrizacao.filter(fil => fil.tipoAtividade)
        if (atividadesExistentes && atividadesExistentes.length > 0) {
          const atividadesFiltradas = []
          atividades.forEach(each => {
            if (!atividadesExistentes.find(fin => fin.tipoAtividade.id === each.id)) {
              atividadesFiltradas.push(each)
            }
          })
          return atividadesFiltradas
        }
      }
      return null
    },
    atividadeSelecionada(value) {
      this.atividadeSelecionadaId = value.id
    },
    focusAtividadeSelect() {
      this.$refs.atividadeSelect.focus()
    },
    onChange(evt) {
      const valorRemovido = this.value.itensChecklist.splice(evt.moved.oldIndex, 1)
      this.value.itensChecklist.splice(evt.moved.newIndex, 0, valorRemovido[0])
      const atividade = { event: evt, grupoAtividade: this.value }
      this.$emit('changeOrdemAtividade', atividade)
    },
  },
}
</script>
